import { useId } from "react";

// Logo officiel fourni — utilisé tel quel (public/logo-blanc.svg), jamais redessiné.
export const Lockup = ({ className = "", height = 46 }) => (
  <img
    src={`${process.env.PUBLIC_URL}/logo-blanc.svg`}
    alt="Logo officiel — COSMETICA BEAUTY AWARDS"
    width={Math.round((1555 / 504) * height)}
    height={height}
    className={`block w-auto select-none ${className}`}
    style={{ height }}
    data-testid="brand-logo"
  />
);

export const WinnerSeal = ({ size = 200, className = "", year = "2027", ...rest }) => {
  const id = useId().replace(/:/g, "");
  const teeth = 56;
  const pts = Array.from({ length: teeth * 2 }, (_, i) => {
    const r = i % 2 ? 91 : 98;
    const a = (i * Math.PI) / teeth;
    return `${(100 + r * Math.cos(a)).toFixed(2)},${(100 + r * Math.sin(a)).toFixed(2)}`;
  }).join(" ");
  const white = { fill: "var(--color-white)" };
  return (
    <svg viewBox="0 0 200 200" width={size} height={size} className={`seal-glow ${className}`} role="img" aria-label="Winner Mark COSMETICA BEAUTY AWARDS" {...rest}>
      <defs>
        <linearGradient id={`g${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" style={{ stopColor: "var(--color-copper)" }} />
          <stop offset="0.5" style={{ stopColor: "color-mix(in srgb, var(--color-copper) 72%, var(--color-white))" }} />
          <stop offset="1" style={{ stopColor: "var(--color-copper)" }} />
        </linearGradient>
        <linearGradient id={`s${id}`} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" style={{ stopColor: "var(--color-white)" }} stopOpacity="0" />
          <stop offset="0.5" style={{ stopColor: "var(--color-white)" }} stopOpacity="0.6" />
          <stop offset="1" style={{ stopColor: "var(--color-white)" }} stopOpacity="0" />
        </linearGradient>
        <path id={`c${id}`} d="M100,100 m-70,0 a70,70 0 1,1 140,0 a70,70 0 1,1 -140,0" />
        <clipPath id={`k${id}`}><polygon points={pts} /></clipPath>
      </defs>
      <polygon points={pts} fill={`url(#g${id})`} />
      <circle cx="100" cy="100" r="84" fill="none" strokeOpacity="0.75" strokeWidth="0.8" style={{ stroke: "var(--color-white)" }} />
      <circle cx="100" cy="100" r="55" style={{ fill: "var(--color-plum)" }} />
      <g className="seal-rotate">
        <text fontSize="8.6" letterSpacing="2" style={{ ...white, fontFamily: "var(--font-sans)", fontWeight: 600 }}>
          <textPath href={`#c${id}`} textLength="432" lengthAdjust="spacing">COSMETICA BEAUTY AWARDS • WINNER MARK • {year} •</textPath>
        </text>
      </g>
      <path d="M100 66 L104 90 L128 94 L104 98 L100 122 L96 98 L72 94 L96 90 Z" fillOpacity="0.95" transform="translate(0 -4)" style={white} />
      <text x="100" y="140" textAnchor="middle" fontSize="12" letterSpacing="3" style={{ ...white, fontFamily: "var(--font-serif)", fontWeight: 600 }}>WINNER</text>
      <g clipPath={`url(#k${id})`}>
        <rect className="seal-shine" x="0" y="-40" width="60" height="280" fill={`url(#s${id})`} />
      </g>
    </svg>
  );
};
